import api from "../api/index";
import notify from "devextreme/ui/notify";
import {getReferenceTypes, getSkillCategories} from "./actions";

const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалось выполнить запрос"
    }
  ]
});

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

  const DELETE_REFERENCE_TYPES_REQUEST = "DELETE_REFERENCE_TYPES_REQUEST";
  const DELETE_REFERENCE_TYPES_COMPLETED = "DELETE_REFERENCE_TYPES_COMPLETED";
  const DELETE_REFERENCE_TYPES_ERROR = "DELETE_REFERENCE_TYPES_ERROR";

const DELETE_SKILL_CATEGORY_REQUEST = "DELETE_SKILL_CATEGORY_REQUEST";
const DELETE_SKILL_CATEGORY_COMPLETED = "DELETE_SKILL_CATEGORY_COMPLETED";
const DELETE_SKILL_CATEGORY_ERROR = "DELETE_SKILL_CATEGORY_ERROR";

  function deleteReferenceTypesRequest() {
    return {
      type: DELETE_REFERENCE_TYPES_REQUEST,
      isDeletingRefTypes: true
    };
  }

  function deleteReferenceTypesCompleted(deletedRefTypes) {
    return {
      type: DELETE_REFERENCE_TYPES_COMPLETED,
      isDeletingRefTypes: false,
      deletedRefTypes
    };
  }

  function deleteReferenceTypesError(deletingRefTypesError) {
    return {
      type: DELETE_REFERENCE_TYPES_ERROR,
      isDeletingRefTypes: false,
      deletingRefTypesError
    };
  }

  export function deleteReferenceTypes(idlist) {
    return async dispatch => {
      dispatch(deleteReferenceTypesRequest());

      const response = await Promise.all(
        idlist.map(id => api.deleteReferenceType(id))
      );

      if (response.every(({ data }) => data.success == true)) {
        dispatch(deleteReferenceTypesCompleted(response));
        dispatch(getReferenceTypes());
      } else {
        dispatch(deleteReferenceTypesError(response));
      }
      return response;
    };
  };

function deleteSkillCategoryRequest() {
  return {
    type: DELETE_SKILL_CATEGORY_REQUEST,
    isDeletingSkillCategories: true
  };
}

function deleteSkillCategoryCompleted(deletedSkillCategories) {
  return {
    type: DELETE_SKILL_CATEGORY_COMPLETED,
    isDeletingSkillCategories: false,
    deletedSkillCategories
  };
}

function deleteSkillCategoryError(deletingSkillCategoriesError) {
  return {
    type: DELETE_SKILL_CATEGORY_ERROR,
    isDeletingSkillCategories: false,
    deletingSkillCategoriesError
  };
}

export function deleteSkillCategories(idlist) {
  return async dispatch => {
    dispatch(deleteSkillCategoryRequest());

    const response = await Promise.all(
      idlist.map(id => api.deleteSkillCategory(id))
    );

    if (response.every(({ data }) => data.success == true)) {
      dispatch(deleteSkillCategoryCompleted(response));
      dispatch(getSkillCategories());
    } else {
      dispatch(deleteSkillCategoryError(response));
    }
    return response;
  };
};

export default {
  DELETE_REFERENCE_TYPES_REQUEST,
  DELETE_REFERENCE_TYPES_COMPLETED,
  DELETE_REFERENCE_TYPES_ERROR,
  DELETE_SKILL_CATEGORY_REQUEST,
  DELETE_SKILL_CATEGORY_COMPLETED,
  DELETE_SKILL_CATEGORY_ERROR,

  deleteReferenceTypes,
  deleteSkillCategories
};
